<template>
    <div class="content">
        <br>
        <div v-if="isMultipleInfomapsClicked">
            <div
                v-for="(value, index) in infomapDetails"
                :key="index"
                class="content-text-info"
            >
                <!-- eslint-disable vue/no-v-html -->
                <p
                    class="content-text-info"
                    v-html="value.textContent"
                />
                <span v-html="value.link" />
                <!--eslint-enable-->
            </div>
        </div>
        <div v-else>
            <p
                v-if="infokartanKuvaus"
                class="content-text-info"
            >
                {{ infokartanKuvaus }}
            </p>
            <!-- eslint-disable vue/no-v-html -->
            <span
                v-if="infokartanLinkki"
                v-html="infokartanLinkki"
            />
            <!--eslint-enable-->
        </div>
        <br>
        <span class="description">{{ description }}</span>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicRightSlotData from "../../../../models/dynamicrighslotdata"

    @Component
    export default class Infokartat extends Vue {
        get rightSlotData(): DynamicRightSlotData {
            return this.$store.getters.rightSlotData
        }

        get infokartanKuvaus(): string | null {
            const data = this.rightSlotData
            return data.textContent ?? ""
        }

        get infokartanLinkki(): string | null {
            const data = this.rightSlotData
            return data.linkki ?? ""
        }

        get isMultipleInfomapsClicked() {
            const data = this.rightSlotData
            return data.infomapDetails?.length !== 0
        }

        get infomapDetails() {
            const data = this.rightSlotData
            return data.infomapDetails
        }

        get description(): string | null {
            return this.$store.getters.apiData[0]?.rightSlotData?.description ?? ""
        }
    }

</script>
